// import React from "react";
// import "./advisory-coucil.css";

// // Images
// import Alysa from "../images/Alysa.jpeg";
// import jacquelyn from "../images/jacquelyn.jpeg";
// import deborah from "../images/deborah.jpeg";
// import Natalie from "../images/Natalie.jpeg";
// import amy from "../images/amy.jpeg";
// import greg from "../images/greg.jpeg";
// import edgar from "../images/edgar.jpeg";
// import heather from "../images/heather.jpeg";
// import shamsha from "../images/shamsa.png";
// import chris from "../images/chris.jpeg";
// import bryan from "../images/bryan-kenna.jpg";

// const Advisory_Council = () => {
//   const divData = [
//     { id: 1, imageUrl: Alysa, title: "Alyssa Reinhart", description: "Strengthen educational pathways into the workforce", linkedin: "https://www.linkedin.com/in/alyssareinhart/" },
//     { id: 2, imageUrl: jacquelyn, title: "Jacquelyn Schulz", description: "Workforce Initiatives, U.S. CSG Strategic Operations at CGI", linkedin: "https://www.linkedin.com/in/jacquelyncraddock/" },
//     { id: 3, imageUrl: deborah, title: "Deborah Kobes", description: "Senior Fellow, Apprenticeship and Workforce", linkedin: "https://www.linkedin.com/in/deborahkobes/" },
//     { id: 4, imageUrl: Natalie, title: "Natalie Miller", description: "Talent Management & Development Fanatic | Relationship Developer | Sales & Marketing Leader | HR", linkedin: "https://linkedin.com/in/dummy-natalie" },
//     { id: 5, imageUrl: amy, title: "Amy Mackenroth", description: "Shaping strategies and opportunities for future workforce growth and innovation with partners nationally.", linkedin: "https://linkedin.com/in/dummy-amy" },
//     { id: 6, imageUrl: greg, title: "Greg Vaughn", description: "Executive Director, Texas Association of Workforce Board", linkedin: "https://linkedin.com/in/dummy-greg" },
//     { id: 7, imageUrl: edgar, title: "Edgar Padilla", description: "Consulting Manager", linkedin: "https://linkedin.com/in/dummy-edgar" },
//     { id: 8, imageUrl: heather, title: "Heather Terenzio", description: "Senior Executive in Workforce Development with a passion for Start-ups and Entrepreneurship", linkedin: "https://linkedin.com/in/dummy-heather" },
//     { id: 9, imageUrl: shamsha, title: "Shamsah Noorani", description: "General Manager, Health Tech Academy", linkedin: "https://linkedin.com/in/dummy-shamsah" },
//     { id: 10, imageUrl: chris, title: "Chris Lofton", description: "General Manager, Health Tech Academy", linkedin: "https://linkedin.com/in/dummy-chris" },
//     { id: 11, imageUrl: bryan, title: "Bryan Kenna", description: "CEO at QuickStart Inc.", linkedin: "https://linkedin.com/in/dummy-bryan" },
//   ];

//   return (
//     <div className="light-bg">

//       <div className="container">
//         <div className="hero-text-clr ad-text text-center fw-bold text-uppercase pt-5">
//           Workforce Development
//         </div>
//         <div className="darkO-txt text-center fw-bold ad-text2">
//           ADVISORY COUNCIL
//         </div>
//       </div>

//       <div className="container mt-5">

//         {/* FIRST ROW (3 CARDS) */}
//         <div className="row custom-width mx-auto">
//           {divData.slice(0, 3).map((item) => (
//             <div key={item.id} className="col-lg-4 col-md-6 mb-4 px-4">
//               <div className="mb-4 pb-4 border mx-2 mainRowCol px-4">

//                 <div className="card-content d-flex flex-column position-absolute mainLinkEdin">
//                   <a href={item.linkedin} target="_blank" rel="noopener noreferrer">
//                     <div className="btnadvisory">

//                       {/* EXACT SVG */}
//                       <svg
//                         stroke=""
//                         fill="currentColor"
//                         strokeWidth="0"
//                         viewBox="0 0 1024 1024"
//                         className="mt-3 p-2 btn-I-ad"
//                         height="50"
//                         width="50"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path d="M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.4-433c-37.9 0-68.8-30.8-68.8-68.8a68.8 68.8 0 1 1 137.6 0c0 38-30.8 68.8-68.8 68.8zm503.3 433H674.6V604.8c0-49.8-9.5-98-71.2-98-60.8 0-61.7 56.9-61.7 101.2v185.7H423.7V411.9h113.9v52.2h1.6c15.9-30 54.6-61.7 112.3-61.7 120.1 0 142.3 79.1 142.3 181.9v209.4z"></path>
//                       </svg>

//                     </div>
//                   </a>
//                 </div>

//                 <img
//                   src={item.imageUrl}
//                   alt={item.title}
//                   className="img-fluid mainImgPort"
//                 />

//                 <h3 className="mt-3 fs-5">{item.title}</h3>
//                 <p>{item.description}</p>

//               </div>
//             </div>
//           ))}
//         </div>

//         {/* REMAINING ROWS (4 PER ROW) */}
//         <div className="row">
//           {divData.slice(3).map((item) => (
//             <div key={item.id} className="col-lg-3 col-md-6 mb-4 px-4">
//               <div className="mb-4 pb-4 border mx-2 mainRowCol px-4">

//                 <div className="card-content d-flex flex-column position-absolute mainLinkEdin">
//                   <a href={item.linkedin} target="_blank" rel="noopener noreferrer">
//                     <div className="btnadvisory">

//                       {/* SAME EXACT SVG */}
//                       <svg
//                         stroke=""
//                         fill="currentColor"
//                         strokeWidth="0"
//                         viewBox="0 0 1024 1024"
//                         className="mt-3 p-2 btn-I-ad"
//                         height="50"
//                         width="50"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path d="M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.4-433c-37.9 0-68.8-30.8-68.8-68.8a68.8 68.8 0 1 1 137.6 0c0 38-30.8 68.8-68.8 68.8zm503.3 433H674.6V604.8c0-49.8-9.5-98-71.2-98-60.8 0-61.7 56.9-61.7 101.2v185.7H423.7V411.9h113.9v52.2h1.6c15.9-30 54.6-61.7 112.3-61.7 120.1 0 142.3 79.1 142.3 181.9v209.4z"></path>
//                       </svg>

//                     </div>
//                   </a>
//                 </div>

//                 <img
//                   src={item.imageUrl}
//                   alt={item.title}
//                   className="img-fluid mainImgPort"
//                 />

//                 <h3 className="mt-3 fs-5">{item.title}</h3>
//                 <p>{item.description}</p>

//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Advisory_Council;
import React from "react";
import AdvisoryHero from "../Components/AdvisoryCouncilComponents/AdvisoryHero/AdvisoryHero";
import AdvisoryHighlights from "../Components/AdvisoryCouncilComponents/AdvisoryHighlights/AdvisoryHighlights";
import AdvisoryCouncilGrid from "../Components/AdvisoryCouncilComponents/AdvisoryCouncilGrid/AdvisoryCouncilGrid";
function Advisory_Council() {
return (
   <>
  <AdvisoryHero/>
 <AdvisoryHighlights/>
 <AdvisoryCouncilGrid/>

   </>
  );
}

export default Advisory_Council;